"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectOption = void 0;
var vue_1 = require("vue");
var Button_1 = require("../components/common/Button");
var TranslateMixin_1 = require("./TranslateMixin");
exports.SelectOption = vue_1.default.component('select-option', {
    props: {
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    components: {
        'Button': Button_1.Button,
    },
    mixins: [TranslateMixin_1.TranslateMixin],
    data: function () {
        return {};
    },
    methods: {
        saveData: function () {
            this.onsave([['1']]);
        },
    },
    template: "<div class=\"wf-component wf-component--select-option\">\n        <div v-if=\"showtitle === true\" class=\"wf-component-title\">{{ $t(playerinput.title) }}</div>\n        <Button v-if=\"showsave === true\" size=\"big\" :onClick=\"saveData\" :title=\"$t(playerinput.buttonLabel)\" :danger=\"playerinput.buttonDanger\" />\n    </div>",
});
//# sourceMappingURL=SelectOption.js.map